import { Flex } from "@chakra-ui/layout";
import { Tag } from "@chakra-ui/react";

interface TagStatusProps {
  icon?: React.ReactNode;
  title: string;
  colorScheme: string;
}

export default function Props({ icon, title, colorScheme }: TagStatusProps) {
  return (
    <Flex>
      <Tag
        rounded={5}
        px={3}
        py={2}
        gap={2.5}
        colorScheme={colorScheme}
        size="sm"
      >
        {icon}
        {title}
      </Tag>
    </Flex>
  );
}
